import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=0575b8fc&scoped=true"
import script from "./user-menu.vue?vue&type=script&lang=js"
export * from "./user-menu.vue?vue&type=script&lang=js"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=0575b8fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575b8fc",
  null
  
)

export default component.exports